import React from 'react';
import PropTypes from 'prop-types';

import mapPin from 'assets/images/map/maps-pin-blue.png';
import Marker from './Marker';

export default function MapPin({ google, image, ...rest }) {
	const icon = new google.maps.MarkerImage(
		image || mapPin,
		new google.maps.Size(30, 42),
		new google.maps.Point(0, 0),
		new google.maps.Point(15, 42),
	);
	return (
		<Marker
			{...rest}
			google={google}
			icon={icon}
		/>
	);
}

MapPin.propTypes = {
	google: PropTypes.shape({
		maps: PropTypes.shape({
			MarkerImage: PropTypes.func,
			Size: PropTypes.func,
			Point: PropTypes.func,
		}),
	}),
	image: PropTypes.string,
};
